module.exports = __webpack_public_path__ + "static/logo_css-e2ede7f93df95de7d802f1dae5e89d95.svg";